export default {
  menus: [ // id必须为$route.name
    {
      id: 'ResourceMenu',
      title: '资源',
      icon: 'icon-ziyuan',
      children: [
        {
          id: 'ComponentList',
          title: '构件',
        }, {
          id: 'ModuleList',
          title: '模块',
          showSoftware: ['AppGarch', 'AppGstr', 'AppGmep'],
        }, {
          id: 'SchemeList',
          title: '模板',
          showSoftware: ['AppGbr'],
        },
      ]
    }, {
      id: 'File',
      title: '文件',
      icon: 'icon-wenjian'
    }, {
      id: 'Member',
      title: '成员',
      icon: 'icon-jindujihua'
    }, {
      id: 'Setting',
      title: '设置',
      icon: 'icon-jindujihua2'
    },
  ]
}
